import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Input from '../elements/Input';

const propTypes = {
  ...SectionProps.types,
  split: PropTypes.bool
}

const defaultProps = {
  ...SectionProps.defaults,
  split: false
}

const Cta = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  split,
  ...props
}) => {

  const outerClasses = classNames(
    'cta section center-content-mobile reveal-from-bottom',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'cta-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider',
    split && 'cta-split'
  );  

  function submitButton(e)
  {
    e.preventDefault();
    let email = document.querySelector("#newsletter");
    console.log(email.value + " email Submission")
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://zbbr7ab94j.execute-api.us-east-1.amazonaws.com/dev", true);

    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
      }
    };
    var data = {
      email: email.value,
      message: "A visitor has subscribed to your Email List for SPPhotonic."
    };


    let success = document.querySelector("#success");
    let error = document.querySelector("#error");

    if (email.value) {
      success.style.display = "block";
      success.innerHTML = "Thanks for submitting";
      email.style.display = "none";
      xhr.send(JSON.stringify(data));

    } else {
        error.style.display = "block";
        error.innerHTML = "Please Submit a Valid Email.";
    }










    // alert('Not Yet Available');
    // alert('Thanks for Subscribing');
  }

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div
          className={innerClasses}
        >
          <div className="cta-slogan">
            <h3 className="m-0">
              Subscribe to Our Mailing List!
              </h3>
          </div>
          <div className="cta-action">
            <Input id="newsletter" type="email" label="Subscribe" labelHidden hasIcon="right" placeholder="Enter your email"
            onKeyPress={event => {
                if (event.key === 'Enter') {
                  submitButton()
                }
              }}>
              <svg width="16" height="12" xmlns="http://www.w3.org/2000/svg">
                <path   d="M9 5H1c-.6 0-1 .4-1 1s.4 1 1 1h8v5l7-6-7-6v5z" fill="#376DF9" />
              </svg>
            </Input>
            <button className="button button-primary button-wide-mobile button-sm" onClick={submitButton} >Submit</button>
            <p className="success" id="success" style={{color:"black"}}></p>
            <p className="error" id="error" style={{color:"black"}}></p>
          </div>
        </div>
      </div>
    </section>
  );
}

Cta.propTypes = propTypes;
Cta.defaultProps = defaultProps;

export default Cta;